import { useRef, useState } from 'react';
import { Swiper, SwiperSlide, SwiperClass } from 'swiper/react';
import { Pagination as SwiperPagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import styles from './Desktop.module.scss';
import { StakingCard } from './StakingCard';
import { Pagination } from './Pagination';
import { useFm } from '@web3/base-hooks';
import { useBbSolConfigContext } from '@/hooks/useBboSolInfo';
import ArrowRight from '@/assets/images/bybitsol/arrow-right.svg';
import { Event } from '@/config/track-config';
import { scTrack } from '@web3/base-tracking';

export const Desktop = () => {
  const fm = useFm();
  const [activeIndex, setActiveIndex] = useState(0);
  const swiperRef = useRef<SwiperClass>();
  const {
    solConfig: { partners },
  } = useBbSolConfigContext();

  if (!partners || partners.length === 0) {
    return null;
  }

  const handlePaginationClick = (index: number) => {
    if (swiperRef.current) {
      // 使用 slideToLoop 来处理循环模式下的跳转
      swiperRef.current.slideToLoop(index, 500);
    }
  };

  return (
    <div className={styles.container} id={'bbsolSlides'}>
      <div className={styles.content}>
        <div className={styles.left}>
          <h2 className={styles.title}>{fm('bbSOLDeFiHighlights')}</h2>
          <p className={styles.name}>{partners?.[activeIndex]?.name}</p>

          <div className={styles.stepDescription}>
            {partners?.[activeIndex]?.stepDescription}
          </div>

          <div className={styles.stepWrapper}>
            {partners?.[activeIndex]?.steps.map((step, index) => (
              <div className={styles.step} key={step}>
                <div className={styles.stepIcon}>{index + 1}</div>
                <div className={styles.stepText}>{step}</div>
              </div>
            ))}
          </div>

          <div
            className={styles.viewMore}
            onClick={() => {
              scTrack(Event.Web3UserClick, {
                page_name: 'StakingWeb_BBSOLhomepage',
                button_name: `Defi_viewmore_${partners?.[activeIndex]?.name}`,
              });
              window.open(partners?.[activeIndex]?.url, '_blank');
            }}
          >
            {fm('viewMore')}
            <ArrowRight />
          </div>
        </div>

        <div className={styles.right}>
          <Swiper
            className={styles.slider}
            direction="vertical"
            modules={[SwiperPagination, Autoplay]}
            effect="cards"
            loop={true}
            rewind={true}
            watchSlidesProgress={true}
            autoplay={{
              delay: 5000,
            }}
            onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            onBeforeInit={(swiper) => {
              swiperRef.current = swiper;
            }}
          >
            {partners.map((slide, index) => (
              <SwiperSlide key={index}>
                <StakingCard key={index} data={slide} />
              </SwiperSlide>
            ))}
          </Swiper>
          <Pagination
            total={partners.length}
            active={activeIndex}
            onPageChange={handlePaginationClick}
          />
        </div>
      </div>
    </div>
  );
};
